import { useSearchParams } from "react-router-dom";

import useI18N from "../../../hooks/useI18N";
import MUIBreadcrumbs from "../../../shared/MUIBreadcrumbs";
import MUITabs from "../../../shared/MUITabs";
import SABox from "../../../shared/SABox";
import SAStack from "../../../shared/SAStack";
import MusharakahMaterials from "./MusharakahMaterials";
import MusharkaDuration from "./MusharkaDuration";
import ProductsColor from "./ProductColor";
import ProductsTable from "./ProductsTable";
import RiskLevel from "./RiskLevel";

const SelectableFieldSetting = () => {
  const { t } = useI18N();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("tab");
  const tabIndex =
    tabParam === "durations"
      ? 1
      : tabParam === "musharakah-materials"
        ? 2
        : tabParam === "risk-level"
          ? 3
          : 0;

  const handleTabChange = (_, newIndex) => {
    let tabValue = "product";
    if (newIndex === 1) tabValue = "durations";
    else if (newIndex === 2) tabValue = "musharakah-materials";
    else if (newIndex === 3) tabValue = "risk-level";
    setSearchParams({ tab: tabValue });
  };

  const breadcrumbsData = [
    { label: "home", href: "/businesses" },
    { label: "settings", href: "/settings" },
    { label: "selectable-field-settings" },
  ];

  return (
    <>
      <SAStack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
      >
        <SAStack>
          <MUIBreadcrumbs breadcrumbsData={breadcrumbsData} />
        </SAStack>
      </SAStack>
      <MUITabs
        tabs={[
          {
            label: t("product"),
            content: (
              <SAStack direction={{ xs: "column", lg: "row" }} gap={2}>
                <SABox sx={{ flex: 1 }}>
                  <ProductsTable />
                </SABox>
                <SABox sx={{ flex: 1 }}>
                  <ProductsColor />
                </SABox>
              </SAStack>
            ),
          },
          {
            label: t("durations"),
            content: (
              <SAStack mt={2}>
                <MusharkaDuration />
              </SAStack>
            ),
          },
          {
            label: t("musharakah-materials"),
            content: (
              <SAStack mt={2}>
                <MusharakahMaterials />
              </SAStack>
            ),
          },
          {
            label: t("risk-level"),
            content: (
              <SAStack mt={2}>
                <RiskLevel />
              </SAStack>
            ),
          },
        ]}
        value={tabIndex}
        onChange={handleTabChange}
      />
    </>
  );
};

export default SelectableFieldSetting;
